import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MessageModule } from 'primeng/message';

export enum MessageType {
    ERROR = "ERROR",
    WARN = "WARN",
    DEBUG = "DEBUG"
} 
export enum ERROR_KEY  {
    EITHER_LESSON_NOT_VALID_OR_NOT_DEEPLINKED ="EITHER_LESSON_NOT_VALID_OR_NOT_DEEPLINKED"
}
export const ERRORS  = {
    [ERROR_KEY.EITHER_LESSON_NOT_VALID_OR_NOT_DEEPLINKED]: `Der Inhalt, den Sie abrufen möchten, ist nicht verfügbar. Bitte wenden Sie sich an Ihre*n Administrator*in. Sie können das Fenster schließen und zur Relias Plattform zurückkehren.`
}
@Component({
  selector: 'app-message',
  standalone: true,
  templateUrl: './message.html',
  imports:[MessageModule]
})
export class MessageComponent{
    private route = inject(ActivatedRoute);
    messageType: MessageType ;
    messageCode: string ;
    message:string;
    constructor(){
        this.messageType = this.route.snapshot.paramMap.get('messageType') as MessageType ;
        this.messageCode = this.route.snapshot.paramMap.get('messageCode') as ERROR_KEY;
        this.message = ERRORS[this.messageCode as ERROR_KEY] 
    }
}